import api from '@/services/Api'

// ----------------------------- o

const namespaced = true;

// ----------------------------- o

const state = {
    errors: {},
    loading: false,
    search: null,
    data: [],
    page: 1,
    category: null, // default category was set to 'all' but not anymore, lookup: GLOBAL_CATEGORIES_REQUEST
    last_page: 1
};

// ----------------------------- o

const getters = {};

// ----------------------------- o

const actions = {
    'KNOWLEDGE_WIKIS_REQUEST': ({commit, dispatch},) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_WIKIS_REQUEST');
            // if(state.last_page >= state.page){}
            let url = 'knowledges/wiki/issues?page=' + state.page;
            // let params = state.category !== 'all' ? {'category_slug' : state.category } : null;
            let params = {'category_slug': state.category};
            // extend params if searching
            if (state.search) params = {...params, 'search': state.search}
            //
            api({url: url, params: params ? params : null, method: 'GET'})
                .then(resp => {
                    commit('KNOWLEDGE_WIKIS_SUCCESS', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('KNOWLEDGE_WIKIS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'KNOWLEDGE_WIKIS_SET_PAGE': ({commit, dispatch}, reset) => {
        return new Promise((resolve, reject) => {
            commit('KNOWLEDGE_WIKIS_SET_PAGE', reset);
            resolve();
        })
    },
    'KNOWLEDGE_WIKIS_SET_SEARCH': ({commit, dispatch}, payload) => {
        console.log(payload)
        commit('KNOWLEDGE_WIKIS_SET_SEARCH', payload ? payload.search : null);
        dispatch('KNOWLEDGE_WIKIS_REQUEST');
    },

    'KNOWLEDGE_WIKIS_SET_CATEGORY': ({commit, dispatch}, category) => {
        commit('KNOWLEDGE_WIKIS_SET_CATEGORY', category);
        dispatch('KNOWLEDGE_WIKIS_SET_PAGE', true);
        dispatch('KNOWLEDGE_WIKIS_REQUEST');
    },
}

// ----------------------------- o

const mutations = {
    'KNOWLEDGE_WIKIS_REQUEST': (state) => {
        state.errors = {};
        state.loading = true;
    },
    'KNOWLEDGE_WIKIS_SUCCESS': (state, resp) => {
        state.last_page = resp.last_page;
        state.loading = false;
        // clear array or concat
        if (resp.data.length === 0) {
            state.data = [];
        } else {
            state.data = state.page > 1 ? state.data.concat(resp.data) : resp.data;
        }
    },
    'KNOWLEDGE_WIKIS_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false;
    },
    'KNOWLEDGE_WIKIS_SET_PAGE': (state, reset) => {
        state.page = reset ? state.page = 1 : state.page + 1;
    },
    'KNOWLEDGE_WIKIS_SET_CATEGORY': (state, category) => {
        state.category = category;
    },
    'KNOWLEDGE_WIKIS_SET_SEARCH': (state, string) => {
        state.search = string;
    }
}

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}